<script setup lang="ts">
import joinContent from "~/content/join.json";

const config = useRuntimeConfig();
const siteOrigin = config.public.mainUrl as string;
const { staticUrl } = useImageUrl();

definePageMeta({
  layout: "static",
});

useSeoMeta({
  title: joinContent.seo.title,
  description: joinContent.seo.description,
});

useHead({
  link: [{ rel: "canonical", href: `${siteOrigin}/join` }],
});
</script>

<template>
  <section class="join">
    <div class="join__left">
      <img
        :src="staticUrl('/Images/biz/event-chef-serving.jpg')"
        alt="join"
        loading="eager"
      />
    </div>
    <div class="join__right">
      <h1 class="pink-text">Cook with &amp;Dine today.</h1>
      <p class="grey-text">
        Please fill out the below form and a member of our team will be in touch shortly to discuss
        your options.
      </p>
      <div class="join__right--form">
        <HubspotForm
          portal-id="139704907"
          form-id="173ac2ee-33e8-485f-b020-acce4281fe4b"
        />
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.join {
  position: relative;
  width: 100%;
  display: flex;
  min-height: 100vh;
  &__left {
    width: 50%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: top;
    }
    @media (max-width: $tablet) {
      display: none;
    }
  }
  &__right {
    padding: 8rem 3%;
    width: 44%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    overflow-y: auto;
    img {
      margin: 0 0.2rem;
    }
    &--form {
      .hs_favourite_cuisines .input ul {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 33%;
        }
      }
    }
    @media (max-width: $tablet) {
      width: 100%;
      height: auto;
      overflow-y: visible;
      padding: 6rem 5% 3rem;
    }
  }
}
</style>
